<template>
    <div class="menu-container" id="mainDiv">
        <fa
            class="close-icon"
            :icon="['far', 'circle-xmark']"
            @click="$emit('toggleSlider')"
        />
        <div class="slider-container">
            <div class="mileage-slider">
                <!-- Mileage Slider -->
                <vue-slider
                    v-if="sliderReady" 
                    ref="mileageSlider"
                    v-model="sliderValue"
                    style="width: 350px"
                    :min="currentMin"
                    :max="currentMax"
                    :interval="currentInterval"
                    :marks="currentMarkers"
                    :tooltip="'none'"
                    @drag-end="$emit('calculateMileage', sliderValue)"
                ></vue-slider>
                <b-row no-gutters class="mileage-details">
                    <p>Radius: <b>{{ sliderValue }}{{ kmToggle ? 'km' : 'mi' }}</b></p>
                    <toggle-button 
                      :sync="true" 
                      class="toggle" 
                      :labels="{checked: 'km', unchecked: 'mi'}" 
                      v-model="kmToggle" 
                      :width="50" 
                      :height="22" 
                      :color="{checked: '#0496e9', unchecked: 'lightgray'}"
                      @change="toggleUnits"
                    />
                </b-row>
            </div>
        </div>
    </div>
</template>
  
<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'MMP_Analytics_MileageSlider',
  components: {
    VueSlider
  },
  data() {
    return {
        sliderValue: 5,
        sliderReady: true,  // To control when the slider is displayed
        miMarkers: {
            5: '5mi',
            10: '10mi',
            20: '20mi',
            30: '30mi',
            40: '40mi',
            50: '50mi'
        },
        kmMarkers: {
            8: '8km',
            16: '16km',
            32: '32km',
            48: '48km',
            64: '64km',
            80: '80km'
        },
        kmToggle: false
    }
  },
  methods: {
    reset() {
        this.sliderValue = this.currentMin;
        this.$emit('calculateMileage', this.sliderValue)
    },
    toggleUnits() {
        const conversionFactor = 1.60934;

        // Hide the slider during the transition
        this.sliderReady = false;

        this.$nextTick(() => {
            if (this.kmToggle) {
                // Convert from miles to kilometers
                this.sliderValue = Math.round(this.sliderValue * conversionFactor);
            } else {
                // Convert from kilometers to miles
                this.sliderValue = Math.round(this.sliderValue / conversionFactor);
            }

            // Ensure the value stays within the new range
            this.sliderValue = Math.min(
                Math.max(this.sliderValue, this.currentMin),
                this.currentMax
            );

            this.$emit('calculateMileage', this.sliderValue)

            // Show the slider again
            this.sliderReady = true;

            this.$emit('unitChange', this.kmToggle)
        });
    },
    handleClick() {
        setTimeout(() => {
            this.$emit('calculateMileage', this.sliderValue)
        }, 100); // Give the emit a slight delay to allow the slider to update its value
    }
  },
  computed: {
    currentMin() {
        return this.kmToggle ? 8 : 5;
    },
    currentMax() {
        return this.kmToggle ? 80 : 50;
    },
    currentInterval() {
        return this.kmToggle ? 8 : 5;
    },
    currentMarkers() {
        return this.kmToggle ? this.kmMarkers : this.miMarkers;
    }
  },
  watch: {
    sliderValue: function (newValue) {
        this.sliderValue = newValue
        this.$emit('sliderChange', newValue)
    },
    sliderReady: function (newValue) {
        if (newValue) {
            setTimeout(() => {
                this.$refs.mileageSlider.$el.addEventListener('mouseup', this.handleClick);
            }, 2000); // Give the emit a slight delay to allow the slider to update its value
        }
    }
  },
  mounted() {
    this.$refs.mileageSlider.$el.addEventListener('mouseup', this.handleClick);
  }
}
</script>

<style>
.close-icon {
    cursor: pointer; 
    position: absolute; 
    top: 5px; 
    right: 5px;
    color: white;
}
.close-icon:hover {
    color: yellow;
}
.menu-container {
    width: 400px;
    height: 90px; 
    background: rgba(6, 47, 86, 0.65);
    position: relative;
    border-radius: 6px;
}
.slider-container {
    width: 400px;
    height: 60px;
    position: absolute;
    top: 25px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    color: white;
}
.mileage-slider {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-direction: column; 
    gap: 22px;
    margin-bottom: 5px;
}

.mileage-slider p {
    height: 20px;
    margin: 0 !important;
}

.mileage-slider b {
    color: yellow;
}
.mileage-details {
    display: flex;
    justify-content: space-evenly;
    align-items: flex-end;
    width: 100%;
}
.mileage-details .toggle.vue-js-switch {
    margin-bottom: -5px;
    border: 1px solid #062f56;
    border-radius: 11px;
}
.vue-js-switch .v-switch-label.v-right {
    color: #062f56 !important;
}
.v-switch-button {
    border: 1px solid #062f56;
}
</style>